import { Button, Card, Grid, Switch } from "@mui/material";
import WBAccordion from "components/_WBcomponents/WBAccordion";
import { WBInput, WBSelect } from "components/_WBcomponents/WBInput";
import { WBLabel, WBTitleLabel } from "components/_WBcomponents/WBLabel";
import React, { useState } from "react";
import { reactLocalStorage } from "reactjs-localstorage";
import { changePasswordService, updateAdmin } from "services/adminService";

function Profile ({

}) {

    const lsAdminProfile = reactLocalStorage.get('user_info')
    const adminProfile = lsAdminProfile ? JSON.parse(lsAdminProfile) : null;

    console.log(adminProfile)

    const [ form, setForm ] = useState({
        _id: adminProfile ? adminProfile._id : '',
        name: adminProfile ? adminProfile.name: '',
        username: adminProfile ? adminProfile.username : '',
    })

    const [ passForm, setPassForm ] = useState({
        oldPassword: '',
        password: ''
    })

    const onChange = (e) => {
        setForm(prev => ({
            ...prev,
            ...e
        }))
    }

    const onChangePassword = (e) => {
        setPassForm(prev => ({
            ...prev,
            ...e
        }))
    }

    const onSubmit = async () => {
        let { data, error } = await  updateAdmin({
            _id: form._id,
            ...form,
            isActive: true
        })
        if (data) { alert('Success') }
    }
    const onSubmitPassword = async () => {
        let { data, error } = await changePasswordService({
            _id: form._id,
            ...passForm
        })
        if (error) { alert(error) }
        if (data) { 
            alert('Success');  
            reactLocalStorage.clear();
            window.location.href = "/";
        }
    }

    return (
        <Grid container xs={12} lg={4}>
            <Grid xs={12}>
                <WBTitleLabel>Update Profile</WBTitleLabel>
            </Grid>
            <Card>
                <Grid container xs={12} lg={12} p={2} spacing={1}>
                    <Grid item xs={12}>
                        <WBInput label={"Name"} onChange={(e) => {
                            onChange({name: e.currentTarget.value})
                        }} value={form.name}/>
                    </Grid>
                    <Grid item xs={12}>
                        <WBInput disabled label={"Username"} onChange={(e) => {
                            onChange({username: e.currentTarget.value})
                        }}  value={form.username}/>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid item xs={12} mt={1}>
                            <Button variant="contained" onClick={() => {
                                onSubmit()
                            }}>{"Update"}</Button>
                        </Grid>
                    </Grid>
                </Grid>
            </Card>
            <Grid item xs={12} mt={1}>
                <WBAccordion title={
                    <WBLabel style={{fontWeight: 'bold'}}>Change Password</WBLabel>
                }>
                    <Grid item container>
                        <Grid item xs={12}>
                            <WBInput label={"Old Password"} type={"password"} onChange={(e) => {
                                onChangePassword({oldPassword: e.currentTarget.value})
                            }}  value={passForm.oldPassword}/>
                        </Grid>
                        <Grid item xs={12}>
                            <WBInput label={"New Password"} type={"password"} onChange={(e) => {
                                onChangePassword({password: e.currentTarget.value})
                            }}  value={passForm.password}/>
                        </Grid>
                    </Grid>
                    <Grid item xs={12}>
                        <Grid item xs={12} mt={1}>
                            <Button variant="contained" onClick={() => {
                                onSubmitPassword()
                            }}>{"Update"}</Button>
                        </Grid>
                    </Grid>
                </WBAccordion>
            </Grid>
        </Grid>
    )
}

export default Profile